import React from 'react';
import { createPortal } from 'react-dom';

const AuthorReferenceModal = ({ isOpen, onClose, authorRef }) => {
  if (!isOpen || !authorRef) return null;

  // Check if there's any meaningful data to display
  const hasData = (
    (authorRef.title && authorRef.title !== `Reference ${authorRef.ar_id}`) ||
    (authorRef.authors && authorRef.authors.length > 0) ||
    authorRef.year ||
    authorRef.doi ||
    authorRef.publisher ||
    authorRef.journal_page_no ||
    authorRef.organization ||
    authorRef.address ||
    authorRef.classification ||
    authorRef.website_url ||
    authorRef.accessed_date
  );

  return createPortal(
    <div className="author-ref-modal-overlay" onClick={onClose}>
      <div className="author-ref-modal-content ev-card-2 ev-radius-small" onClick={(e) => e.stopPropagation()}>
        <div className="author-ref-modal-header">
          <h5 className="author-ref-modal-title ev-med-p-blue">
            <i className="bi bi-book-fill"></i>
            Reference Details
          </h5>
          <button
            type="button"
            className="ev-btn-text-only-fill ev-fs-20"
            onClick={onClose}
            aria-label="Close"
          >
            <i className="bi bi-x"></i>
          </button>
        </div>
        
        <div className="author-ref-modal-body scrollable-element">
          {!hasData ? (
            <div className="author-ref-empty-state">
              <i className="bi bi-info-circle"></i>
              <p className="ev-small-p-blue">No additional information available for this reference.</p>
            </div>
          ) : (
            <>
              {/* Title */}
              {authorRef.title && authorRef.title !== `Reference ${authorRef.ar_id}` && (
                <div className="author-ref-field">
                  <label className="ev-small-p-blue">Title:</label>
                  <p className="ev-reg-p-dark">{authorRef.title}</p>
                </div>
              )}

              {/* Authors */}
              <div className="author-ref-field">
                <label className="ev-small-p-blue">Authors:</label>
                {authorRef.authors && authorRef.authors.length > 0 ? (
                  <p className="ev-reg-p-dark">{authorRef.authors.join(', ')}</p>
                ) : (
                  <p className="ev-reg-p-dark author-ref-anonymous">Anonymous</p>
                )}
              </div>

              {/* Year */}
              {authorRef.year && (
                <div className="author-ref-field">
                  <label className="ev-small-p-blue">Year:</label>
                  <p className="ev-reg-p-dark">{authorRef.year}</p>
                </div>
              )}

              {/* DOI */}
              {authorRef.doi && (
                <div className="author-ref-field">
                  <label className="ev-small-p-blue">DOI:</label>
                  <p className="ev-reg-p-dark">
                    <a 
                      href={`https://doi.org/${authorRef.doi}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      {authorRef.doi} <i className="bi bi-box-arrow-up-right ms-1"></i>
                    </a>
                  </p>
                </div>
              )}

              {/* Publisher */}
              {authorRef.publisher && (
                <div className="author-ref-field">
                  <label className="ev-small-p-blue">Publisher:</label>
                  <p className="ev-reg-p-dark">{authorRef.publisher}</p>
                </div>
              )}

              {/* Journal/Page Number */}
              {authorRef.journal_page_no && (
                <div className="author-ref-field">
                  <label className="ev-small-p-blue">Journal/Pages:</label>
                  <p className="ev-reg-p-dark">{authorRef.journal_page_no}</p>
                </div>
              )}

              {/* Website URL */}
              {authorRef.website_url && (
                <div className="author-ref-field">
                  <label className="ev-small-p-blue">Website:</label>
                  <p className="ev-reg-p-dark">
                    {/^https?:\/\//i.test(authorRef.website_url) ? (
                      <a
                        href={authorRef.website_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {authorRef.website_url} <i className="bi bi-box-arrow-up-right ms-1"></i>
                      </a>
                    ) : (
                      authorRef.website_url
                    )}
                  </p>
                </div>
              )}

              {/* Accessed Date */}
              {authorRef.accessed_date && (
                <div className="author-ref-field">
                  <label className="ev-small-p-blue">Accessed:</label>
                  <p className="ev-reg-p-dark">{authorRef.accessed_date}</p>
                </div>
              )}

              {/* Organization */}
              {authorRef.organization && (
                <div className="author-ref-field">
                  <label className="ev-small-p-blue">Organization:</label>
                  <p className="ev-reg-p-dark">{authorRef.organization}</p>
                </div>
              )}

              {/* Address */}
              {authorRef.address && (
                <div className="author-ref-field">
                  <label className="ev-small-p-blue">Address:</label>
                  <p className="ev-reg-p-dark">{authorRef.address}</p>
                </div>
              )}

              {/* Classification */}
              {authorRef.classification && (
                <div className="author-ref-field">
                  <label className="ev-small-p-blue">Classification:</label>
                  <p className="ev-reg-p-dark">{authorRef.classification}</p>
                </div>
              )}
            </>
          )}
        </div>

        <div className="author-ref-modal-footer">
          <button
            type="button"
            className="ev-btn-blue-fill-round ev-bold-reg"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AuthorReferenceModal;